import { useQuery } from "@tanstack/react-query";
import { type PlacementsRead, placementStepsDone } from "./setupSteps";

/**
 * The four placements as App Bridge reports them (`shopify.app.extensions()`), read again
 * whenever the merchant comes back to the app, so a block placed in Shopify's editor shows done
 * (and unlocks "Create a box") without a reload. The app reads it once, for Home's setup guide and
 * for every "Create a box".
 */
export function usePlacements(): PlacementsRead {
  const placements = useQuery({
    queryKey: ["app-extensions"],
    queryFn: () => shopify.app.extensions(),
    refetchOnWindowFocus: true,
  });
  if (placements.data) return placementStepsDone(placements.data);
  return placements.isError ? "failed" : "pending";
}
